import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const LicensingThankYou = () => {
  return (
    <div className="min-h-screen bg-blue-950/20 flex items-center justify-center py-20">
      <Helmet>
        <title>Inquiry Received — Thank You | SALAR Technologies</title>
        <meta name="description" content="Your SALAR Technologies licensing inquiry was received. SALAR will respond within two business days with a one-page mutual NDA." />
        <meta property="og:title" content="Inquiry Received — Thank You | SALAR Technologies" />
        <meta property="og:description" content="Your SALAR Technologies licensing inquiry has been received." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.salartechnologies.com/licensing/thank-you" />
        <link rel="canonical" href="https://www.salartechnologies.com/licensing/thank-you" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center" data-testid="licensing-thankyou">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-500/15 border border-emerald-400/40 text-emerald-300 mb-6">
            <CheckCircle size={32} />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-4">
            Inquiry received.
          </h1>
          <p className="text-lg text-blue-100/90 leading-relaxed mb-2">
            Thank you. Your licensing inquiry has been routed to{' '}
            <span className="text-cyan-200">licensing@salartechnologies.com</span>.
          </p>
          <p className="text-base text-blue-100/80 leading-relaxed mb-8">
            SALAR will respond within <strong className="text-white">two business days</strong> with a one-page mutual
            NDA. After NDA execution we will schedule a 30-minute briefing call and email the full Licensing Brief for
            the patent(s) you selected.
          </p>

          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/licensing" data-testid="licensing-thankyou-portfolio">
              <Button className="bg-cyan-500 hover:bg-cyan-400 text-[#0a1628] font-bold px-6">
                Back to Patent Portfolio <ArrowRight className="ml-2" size={16} />
              </Button>
            </Link>
            <a href="mailto:licensing@salartechnologies.com" data-testid="licensing-thankyou-email">
              <Button variant="outline" className="border-cyan-400 text-cyan-200 hover:bg-cyan-400/10">
                <Mail className="mr-2" size={16} /> Email licensing@
              </Button>
            </a>
          </div>

          <p className="text-[11px] text-blue-300/60 italic mt-12 max-w-xl mx-auto">
            All licensing discussions are subject to mutual non-disclosure agreement. This page is provided for
            informational purposes only.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LicensingThankYou;
